export default __webpack_public_path__ + "static/media/Group 36617.85ed2069.svg";